
const setEqualHeightForShuffleItems = function (childItemSelector) {
    //selects all items
    const elements = [...childItemSelector.querySelectorAll('.wpTeamMember:not(.wpTeamMemberRow)')];
    //reset heights
    elements.forEach((item, index) => {
        item.style.height = "auto";
    });
    //puts the height of all items in an array
    const heights = [];
    elements.forEach((item, index) => {
        heights[index] = item.offsetHeight;
    });
    //gets the highest value out of the array
    const maxHeight = Math.max(...heights);

    elements.forEach((item, index) => {
        item.style.height = maxHeight + "px";
    });

};

document.addEventListener('DOMContentLoaded', function (event) {
    if (document.getElementsByClassName('wpContentTeam').length > 0) {
        document.querySelectorAll('.wpContentTeam').forEach(item => {
            const element = item.querySelector('.shuffle-container');
            if (element) {
                // set equalHeights for all shuffle items
                setEqualHeightForShuffleItems(element);
                const Shuffle = window.Shuffle;
                const shuffleInstance = new Shuffle(element, {
                    itemSelector: '.wpTeamMember',
                    buffer: 10,
                });

                // sets the apsect ratio for the placeholder images checking the aspect ratio of the first image
                setPlaceholderImageAspectRatio(element);

                item.querySelectorAll('.filter-button').forEach(filterBtn => {
                    filterBtn.addEventListener('click', event => {
                        shuffleInstance.filter(event.target.getAttribute('data-filter'));

                        for (const sibling of event.target.parentNode.children) {
                            if (sibling !== event.target.parentNode) {
                                sibling.classList.remove('active');
                            }
                        }

                        event.target.classList.remove('active');
                        event.target.classList.add('active');

                        let visibleItems = 0;
                        // count how many shuffleInstance.items are visible
                        shuffleInstance.items.forEach(item => {
                            if (item.isVisible) {
                                visibleItems++;
                            }
                        });

                        const ariaLive = document.getElementById(filterBtn.getAttribute('aria-controls'));
                        ariaLive.innerText = ' Aktuell gefiltert nach ' + filterBtn.innerText + '. ' + visibleItems + '  Feuerwehrmitglieder werden angezeigt.';
                    });
                });
            }
        });
    }
});

// sets the apsect ratio for the placeholder images checking the aspect ratio of the first image
function setPlaceholderImageAspectRatio(element) {
    if(!element) return;

    // get the images with the placeholder class
    const placeholderImages = element.querySelectorAll('.placeholder-image');

    // get the aspect ratio of the first image
    const firstElement = element.querySelector('.member-image');
    if(!firstElement) return;

    const aspectRatio = element.querySelector('.member-image').width / element.querySelector('.member-image').height;

    // set the aspect ratio of the images
    placeholderImages.forEach(image => {
        image.classList.add('object-cover');
        image.style.aspectRatio = aspectRatio;
    });
}

window.addEventListener('resize', function () {

    if (document.getElementsByClassName('wpContentTeam').length > 0) {
        document.querySelectorAll('.wpContentTeam').forEach(item => {
            const element = item.querySelector('.shuffle-container');
            if (element) {
                // set equalHeights for all shuffle items
                setEqualHeightForShuffleItems(element);
            }
        });
    }
});

